module.exports = __webpack_public_path__ + "static/media/text-box.eac47966.svg";